var svgURI = 'http://www.w3.org/2000/svg';

function createElement(name) {
  return document.createElementNS(svgURI, name);
}

exports.createElement = createElement;


//////////////////
// WEBPACK FOOTER
// ./~/zrender/lib/svg/core.js
// module id = 419
// module chunks = 8